(function () {
  'use strict';

  angular
    .module('app.reports', []);

})();